import $ from 'jquery';
import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import './style.scss';
import { EMPLOYER_WORKFLOW_STATUS } from '../../../../employer/constants/employer-workflow';
import { AUTO_FETCH_FEEDBACK_REASON } from './service';

export class CandidateFitTooltip {
    /* @ngInject */
    constructor($scope, $timeout, $filter, $element, CandidateFitTooltipService, $stateParams) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$element = $element;
        this.candidateFitTooltipService = CandidateFitTooltipService;
        this.$stateParams = $stateParams;
        this.isSamplesView = $stateParams.workflowStep === 'Samples';
        this.isSamplesView = $stateParams.workflowStep === 'Samples';
        this.$scope.AUTO_FETCH_FEEDBACK_REASON = AUTO_FETCH_FEEDBACK_REASON;
    }

    $onChanges() {
        const { candidate } = this;
        this.$scope.candidate = candidate;
        this.showfeedbackTooltip(candidate);

        this.isAutoFetchVisible = this.candidateFitTooltipService.getAutoFetchCandidateState(candidate);
        this.isGoodFitVisible = !this.isSamplesView
            && !this.isAutoFetchVisible
            && this.candidateFitTooltipService.getGoodFitVisibilityState(candidate);
        this.isBadFitVisible = !this.isSamplesView && this.candidateFitTooltipService.getBadFitVisibilityState(candidate);
        this.isPendingVisible = !this.isSamplesView && this.candidateFitTooltipService.getPendingVisibilityState(candidate);
        this.isReadyForSendVisible = !this.isSamplesView && this.candidateFitTooltipService.getReadyForSendVisibilityState(candidate);
        this.isSampleVisible = this.isSamplesView && this.candidateFitTooltipService.getSampleVisibleState(candidate);
        this.isUnselectedSampleVisible = this.isSamplesView && this.candidateFitTooltipService.getUnSelectedSampleVisibleState(candidate);
        // eslint-disable-next-line max-len
        this.isGoodPreliminaryFeedbackVisible = this.isSamplesView && this.candidateFitTooltipService.getGoodPreliminaryFeedbackVisibleState(candidate);
        this.isBadPreliminaryFeedbackVisible = this.isSamplesView && this.candidateFitTooltipService.getBadPreliminaryFeedbackVisibleState(candidate);
        this.isEmployerBackToFullServiceVisible = this.candidateFitTooltipService.getEmployerBackToFullServiceVisibilityState(candidate);
        this.feedbackDate = this.candidateFitTooltipService.getFeedbackDate(candidate);
        this.feedbackProviderName = this.candidateFitTooltipService.getFeedbackProviderName(candidate);
    }

    showfeedbackTooltip(candidate) {
        if (candidate) {
            candidate.leftColRejectionReasons = '';
            candidate.rightColRejectionReasons = '';
            const feedback = this.candidateFitTooltipService.getFeedbackFromCandidate(candidate);
            const hasFeedback = !!feedback;
            const canProceed = hasFeedback && feedback.grades &&
                feedback.grades.length > 0 &&
                feedback.grades[0].reasons &&
                feedback.grades[0].reasons.length > 0;

            if (canProceed) {
                for (let i = 0; i < feedback.grades[0].reasons.length; i++) {
                    if (i % 2 === 0) {
                        candidate.leftColRejectionReasons += `<li>${
                            this.$filter('translate')(feedback.grades[0].reasons[i])}</li>`;
                    } else {
                        candidate.rightColRejectionReasons += `<li>${
                            this.$filter('translate')(feedback.grades[0].reasons[i])}</li>`;
                    }
                }
            }

            const freeText = _.get(feedback, 'freeText', '');
            this.formattedFreeText = this.getFormattedFreeText(freeText);

            this.$timeout(() => $(this.$element)
                .find(`[data-toggle="tooltip-${candidate.talentID || candidate.talentId}"]`)
                .tooltip({}));
        }
    }

    getFormattedFreeText(freeText) {
        if (!freeText) {
            return null;
        }

        const commentHtml = (freeText || '').split('\n').map(item => `${item}<br/>`).join('');

        return `<div class="formatted-free-text">${commentHtml}</div>`;
    }

    completeSourcingFeedback(candidate) {
        candidate.returnCompleteSourcingTip = null;
        const statusList = [];
        const candidateReturnSourceComplete = candidate.workflow &&
            candidate.workflow.employerStatus &&
            candidate.workflow.employerStatus.reason &&
            candidate.workflow.employerStatus.reason === 'employer_back_to_full_service';
        const showStatuses = [EMPLOYER_WORKFLOW_STATUS.REVIEWED, EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT];
        const showStatusTranslations = [this.$filter('translate')('CLAIMED_EMPLOYER'), this.$filter('translate')('INTERVIEW_AND_ASSESSMENT_EMPLOYER'), this.$filter('translate')('NEGOTIATION_EMPLOYER')];
        if (candidateReturnSourceComplete) {
            const arrayLen = candidate.workflow.employerStatus.history.length;
            for (let i = arrayLen - 1; i >= 0; i--) {
                const status = candidate.workflow.employerStatus.history[i].status;
                const statusIndex = showStatuses.indexOf(status);
                if (statusIndex === -1) continue;
                const translatedStatus = showStatusTranslations[statusIndex];
                statusList.push(translatedStatus);
            }
            if (statusList.length) {
                const statusListMesasge = statusList[statusList.length - 1];
                const noticeTranslated = this.$filter('translate')('SENT_BACK_FROM_EMPLOYER_TIP_NOTICE');
                candidate.returnCompleteSourcingTip1 = `${noticeTranslated}`;
                candidate.returnCompleteSourcingTip2 = `"${statusListMesasge}"`;
            }
            candidate.showReturnCompleteSourcingTip = !!candidate.returnCompleteSourcingTip1;
        }

        this.$timeout(() => {
            $(this.$element)
                .find(`[data-toggle="tooltip-${candidate.talentID}"]`)
                .tooltip({});
        });
    }
}

export const CandidateFitTooltipConfiguration = {
    template,
    bindings: {
        candidate: '<',
    },
    controller: CandidateFitTooltip,
    controllerAs: 'candidateFitTooltipCtrl',
};

angular.module('TALENYA-FE')
    .component('candidateFitTooltip', CandidateFitTooltipConfiguration);
